module.exports = __webpack_public_path__ + "media/images/front/university_hospitals/university_fuh-7dc2b4d33eddcaf16c7845c5350157cb.png";